<template>
    <div class="topbar-container up-panel">
        <div class="scrollbar-container">
            <div class="title fz_40">上传并提交您的银行卡正面照片</div>
            <div class="message c_999 fz_24">拍照时确保图像清晰，避免反光影响，以提高识别的正确率。</div>
            <validation-observer class="up-container" v-slot="{ invalid }" ref="form" tag="div">
                <validation-provider
                    rules="required"
                    :customMessages="{required:'请上传本人银行卡正面照片'}"
                    tag="div"
                    class="up-el r8 shadow"
                >
                    <input type="hidden" v-model="formData.filePath" />
                    <div
                        class="img-positive bg-cover img"
                        :style="formData.filePath&&{backgroundImage: `url('${formData.filePath}')`}"
                        @click="onUpImg('filePath')"
                    ></div>
                    <div class="tc c_666 fz_28">
                        点击上传本人银行卡
                        <span class="c_warning">正面</span>
                    </div>
                </validation-provider>
                <div class="bh bc footBar">
                    <van-button
                        :class="getBtnCls(invalid)"
                        @click="onSaveClick"
                        class="btn btn-goodbuy"
                    >
                        <span class="fz_30 btn-span">立即上传</span>
                    </van-button>
                </div>
            </validation-observer>
        </div>
    </div>
</template>

<script>
import { verificationBank } from "@/api/card";
import { user } from "@/mixin/user";
import { mixinValid } from "@/mixin/valid";
import { cuImage } from "@/utils/bridge";
export default {
    mixins: [user, mixinValid],
    name: "CardBankUp",
    data() {
        return {
            formData: { filePath: "", toastMessage: "正在识别中..." },
            // 微信原生功能配置
            wx: {}
        };
    },
    created() {
        if (this.$store.state.isDev) {
            this.formData = {
                // filePath: 'https://www.zzbjr.cn/akfile/view/cos/file/head/20200415/20041514434299009929.jpeg',
                filePath:
                    "https://www.zzbjr.cn/akfile/view/akfile/view/cos/file/head/20200415/20041516150311200791.jpg",
                toastMessage: "正在识别中..."
            };
        }
    },
    methods: {
        // 上传图片
        onUpImg: function(dataName) {
            cuImage(this.wx).then(res => {
                this.formData[dataName] = res;
            });
        },
        onSaveClick() {
            const me = this;
            me.validForm().then(() => {
                verificationBank(me.formData).then(res => {
                    me.$store.state.money.isUpBank = true;
                    const data = res.data;
                    data.bankCardTypeId = data.bankTypeId;
                    me.$store.state.money.bankData = data;
                    me.backGo();
                });
            });
        }
    }
};
</script>

<style scoped lang="scss">
@include img-list("~@/assets/imges/card/", "positive", "back");
</style>
